import { Service } from "@reporting/rp-app-host";
import { File } from "@reporting/rp-types/etl";

export async function downloadEtlFile(client: Service, file: Pick<File, 'id_file' | 'input_file'>): Promise<void> {
	const fileName = file.input_file?.split(/[\\/]/).pop() || `file_${file.id_file}`;
	await client.download(`files/${file.id_file}/download`, { fileName });
}

export function uploadEtlFile(client: Service, idFile: number): Promise<boolean> {
	return new Promise<boolean>((resolve, reject) => {
		const input = document.createElement('input');
		input.type = 'file';
		input.onchange = async () => {
			if (!input.files?.length) return resolve(false);
			try {
				const fd = new FormData();
				fd.append('file', input.files[0]);
				await client.post(`io/import/${idFile}`, fd);
				resolve(true);
			} catch (e) {
				reject(e);
			}
		};
		input.click();
	});
}
